import React from "react";
export default function BadgeArtwork({
  image,
  name,
  property,
  large=false,
  medal=false,
}: {
  image: string;
  name: string;
  property?:string;
  large?:boolean;
  medal?:boolean;
}) {
  if(image)return <img src={image} alt={name} className={`${large?'h-36 w-36':'h-28 w-24'} shrink-0 object-contain`}/>;
  return (
    <div data-artwork={medal?'medal':'patch'} className={`${medal?(large?'h-36 w-36':'h-24 w-24'):(large?'min-h-36 w-28':'min-h-28 w-24')} shrink-0 ${medal?'rounded-full':'rounded-t-[2rem] rounded-b-xl'} bg-usda-800 border-2 border-[#b9ac7e] flex flex-col gap-2 items-center justify-center overflow-hidden p-2 text-[#f1ead5]`}>
      <span className="text-[10px] tracking-widest uppercase">{property||'Sonata Fields'}</span><span aria-hidden="true" className="font-serif text-3xl">{name.split(/\s+/).filter(Boolean).slice(0,2).map(word=>word[0]).join('').toUpperCase()}</span><span className="text-[10px] text-center leading-tight">{name}</span>
    </div>
  );
}
